import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useIconInformation from './useIconInformation';
import styles from './IconInformation.module.less';

function IconInformation({
  className, infoData, labelData, icon,
  src, alt, isIcon,
}) {

  const {
    showModal,
  } = useIconInformation();

  const image = (isIcon) ? (
    <FontAwesomeIcon
      className={className}
      icon={icon}
      onClick={showModal}
    />
  ) : (
    <button className={styles.button} type="button" onClick={showModal}>
      <img
        src={src}
        alt={alt}
        className={className}
      />
    </button>
  );

  return (
    <>
      <div className={styles.wrapper}>
        {image}
      </div>
      <div className={styles.wrapperLetter}>
        <b>
          <p className={styles.paragraph}>

            {labelData}

          </p>
          <p className={styles.paragraph}>
            {infoData}
          </p>

        </b>
      </div>
    </>
  );

}

IconInformation.propTypes = {
  className: PropTypes.string,
  infoData: PropTypes.string,
  labelData: PropTypes.string,
  icon: PropTypes.object,
  src: PropTypes.any,
  alt: PropTypes.string,
  isIcon: PropTypes.bool,
};

IconInformation.defaultProps = {
  className: null,
  infoData: 'No Data',
  labelData: 'No Data',
  icon: {},
  src: {},
  alt: 'No Data',
  isIcon: true,
};

export default IconInformation;
